<template>
  <b-container id="login">
    <div class="content" @keyup.enter="login">
      <div class="text-center"><img class="w-50" src="@/assets/logo.jpg"></div>
      <div>
        <h1 class="common__main-title">Login</h1>
        <div class="input-loginId">
          <input type="text" placeholder='"Tutor ID" or "Employee ID"' v-model="loginId">
        </div>
        <div class="input-password">
          <input
            :type="isShowPassword ? 'text' : 'password'"
            placeholder="password"
            v-model="password"
          />
          <font-awesome-icon
            v-if="!isShowPassword"
            :icon="'eye'"
            class="password-lock"
            @click="showPassword"
          />
          <font-awesome-icon
            v-else
            :icon="'eye-slash'"
            class="password-open"
            @click="showPassword"
          />
        </div>
      </div>
      <div class="error-text text-center" v-show="error">{{ error }}</div>
      <div class="d-flex justify-content-center mt-4">
        <b-button
          pill
          variant="primary"
          @click="login"
        >
          <font-awesome-icon v-show="isLoading" icon="spinner" spin />
          Login
        </b-button>
      </div>
      <div class="d-flex justify-content-center mt-2">
        If you cannot log in, please contact the 6F staff
      </div>
    </div>
  </b-container>
</template>

<script>
import _ from 'lodash'

export default {
  data() {
    return {
      isShowPassword: false,
      isLoading: false,
      loginId: '',
      password: '',
      error: '',
    };
  },
  methods: {
    async login() {
      if (this.isLoading) {
        return
      }

      // idまたはpasswordが未入力の場合
      if (_.isEmpty(this.loginId) || _.isEmpty(this.password)) {
        this.error = 'Please enter the correct login ID and password.'
        return
      }

      this.isLoading = true

      try {
        await this.$store.dispatch('login', { loginId: this.loginId, password: this.password })
        // 認証成功後、redirect urlがある場合はそちらに遷移
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push({ name: 'Home' });
        }
      } catch (error) {
        this.error = 'Please enter the correct login ID and password.'
        if (error.response?.status === 423) {
          this.error = 'Password attempts exceeded. Please try after a while.'
        }
        this.isLoading = false
      }
    },

    showPassword() {
      this.isShowPassword = !this.isShowPassword;
    },
  },
};
</script>

<style scoped>
#login{
  width:100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content{
  width:500px;
  min-height: 280px;
  padding: 70px 50px;
  background:#003d69;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 4px 5px 6px #C0C0C0;
}

.input-loginId {
  margin:auto;
  margin-bottom:20px;
  width:60%;
}

.input-password {
  margin:auto;
  position: relative;
  width:60%;
}

.input-password input {
  padding-right:40px;
}

.password-lock , .password-open {
  width: 20px;
  height: 20px;
  position:absolute;
  top:0;
  bottom:0;
  margin: auto;
  right:10px;
  color: #2E75B5;
}

input {
  font-size: 18px;
  padding: 5px 10px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

</style>
